function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFFFFF;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M564,192h-76.9L347.9,37.3c-5.9-6.6-16-7.1-22.6-1.2s-7.1,16-1.2,22.6l120,133.3H131.9l120-133.3 c5.9-6.6,5.4-16.7-1.2-22.6c-6.6-5.9-16.7-5.4-22.6,1.2L88.9,192H12c-6.6,0-12,5.4-12,12v8c0,6.6,5.4,12,12,12h16.4l29.8,214.6 c3.3,23.7,23.6,41.4,47.5,41.4h364.4c24,0,44.2-17.7,47.5-41.4L547.6,224H564c6.6,0,12-5.4,12-12v-8C576,197.4,570.6,192,564,192z  M486.1,434.2c-1.1,7.9-7.9,13.8-15.8,13.8H105.8c-7.9,0-14.8-5.9-15.8-13.8L60.8,224h454.5L486.1,434.2z M304,280v112 c0,8.8-7.2,16-16,16c-8.8,0-16-7.2-16-16V280c0-8.8,7.2-16,16-16C296.8,264,304,271.2,304,280z M416,280v112c0,8.8-7.2,16-16,16 s-16-7.2-16-16V280c0-8.8,7.2-16,16-16S416,271.2,416,280z M192,280v112c0,8.8-7.2,16-16,16s-16-7.2-16-16V280c0-8.8,7.2-16,16-16 S192,271.2,192,280z"
});

var SvgIconOrderbook = function SvgIconOrderbook(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 576 512",
    style: {
      enableBackground: "new 0 0 576 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconOrderbook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_orderbook.534a869e.svg";
export { ForwardRef as ReactComponent };